module.exports = __webpack_public_path__ + "img/embersadrift-screenshot-01.4f73020e.jpg";